import { Card, Flex, Heading, Text, Button } from '@aws-amplify/ui-react';
import { useUserQuery } from '../common/useUserQuery';
import { useFactsSheetsQuery } from './api/useFactsSheetQuery';
import { useState } from 'react';
import FactSheetEditDetails from './FactsSheetEditPage';
import { useFactsSheetDeleteMutation } from './api/useFactsSheetMutation';

export default function FactsSheetCard() {
  const { data: userQueryData } = useUserQuery();
  const { data } = useFactsSheetsQuery(userQueryData?.patientUserId);
  const [editingId, setEditingId] = useState(null);

  const { mutate: factsSheetDeleteMutation } = useFactsSheetDeleteMutation();

  const handleOnDelete = (id) => {
    factsSheetDeleteMutation(id);
  };

  const handleEdit = (id) => {
    if (editingId !== id) {
      setEditingId(null);
      setTimeout(() => setEditingId(id), 0);
    }
  };

  if (data) {
    return (
      <div>
        {editingId && (
          <Card variation="elevated" padding="small" margin="small">
            <FactSheetEditDetails
              id={editingId}
              onClose={() => setEditingId(null)}
            />
          </Card>
        )}
        {data.map((factsSheet) => (
          <Card
            key={factsSheet.id}
            variation="elevated"
            padding="small"
            margin="small"
          >
            <Flex direction="row" alignItems="flex-start">
              <Flex direction="column" alignItems="flex-start" width="100%">
                <Heading level={5}>{factsSheet?.sectionTitle}</Heading>
                <Text>{factsSheet?.sectionDescription}</Text>
                <Flex direction="row" alignItems="flex-start">
                  <Button
                    variation="primary"
                    onClick={() => handleEdit(factsSheet.id)}
                  >
                    Edit
                  </Button>
                  <Button variation="primary" colorTheme="error"  onClick={handleOnDelete.bind(this, factsSheet.id)}>
                    Delete
                  </Button>
                </Flex>
              </Flex>
            </Flex>
          </Card>
        ))}
      </div>
    );
  }
  return null;
}
